/** The fixed app header the main scroller sits below (see layout/styles.ts). */
const HEADER_HEIGHT_MD = 77;

/** The padding every in-house game page puts around its grid. */
const GAME_PAGE_PADDING = 32;

/**
 * The height a game's surface takes on desktop.
 *
 * An in-house game stacks a header, a stage and the bet controls into one
 * column. Left to size itself the stage keeps growing, which pushes the
 * controls past the fold and makes placing a bet a scroll away, so on desktop
 * the surface takes exactly the screen it has and the stage flexes inside it.
 */
export const GAME_SURFACE_HEIGHT = `calc(100vh - ${HEADER_HEIGHT_MD + GAME_PAGE_PADDING}px)`;

/**
 * Past this the screen is too short to divide: the header, controls and stage
 * no longer fit whatever we do, so the surface goes back to its natural height
 * and the page scrolls rather than clipping the game.
 */
export const GAME_SURFACE_SHORT_SCREEN = "@media (max-height: 640px)";

/**
 * The width of a game's controls column on desktop.
 *
 * Wide enough for a stake field with its quick-amount buttons under it, narrow
 * enough that the stage next to it still owns the page.
 */
export const BET_COLUMN_WIDTH = 320;
